import { render, staticRenderFns } from "./DoubleSliderFilter.vue?vue&type=template&id=ff0359ec&scoped=true"
import script from "./DoubleSliderFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoubleSliderFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DoubleSliderFilter.vue?vue&type=style&index=0&id=ff0359ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0359ec",
  null
  
)

export default component.exports